import { Box, Divider, Typography, Tabs, Tab } from "@mui/material";
import { useCallback, useReducer, useState } from "react";
import EnhancedTable from "../../../enhancedTable/EnhancedTable";
import { isLocalDev } from "../../../../utils/environment";
import { ValidDataService } from "../../../../service/validDataService";
import useAbortController from "../../../../hooks/useAbortController";
import useDialogModal from "../../../../hooks/useDialogModal";
import ConfirmationDialog from "../../../ui/confirmationDialog";
import { toast } from "react-toastify";
import validLookup from "../../../../utils/validLookup";
import ValidContactInputForm from "./validContactInputForm";
import ValidContactEditForm from "./validContactEditForm";
import EditIcon from "@mui/icons-material/Edit";
import { useValidInventoryContactColumns } from "./useValidInventoryContactColumns";
import { ContentCopy } from "@mui/icons-material";
import ContactLensSchedules from "./contactLensSchedules/contactLensSchedules";
import ContactLensMaterials from "./contactLensMaterials/contactLensMaterials";
import ContactLensModels from "./contactLensModels/contactLensModels";
import ContactLensPricing from "./contactLensPricing/contactLensPricing";

function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

export default function Contacts() {
    const [tabValue, setTabValue] = useState(0);
    const [ValidContactInputDialog, showValidContactInputForm] = useDialogModal(ValidContactInputForm);
    const [ValidContactEditDialog, showValidContactEditForm] = useDialogModal(ValidContactEditForm);
    const [
        ConfirmationDialogComp,
        showConfirmationDialog,
        closeConfirmationDialog,
    ] = useDialogModal(ConfirmationDialog);
    //const columns = useValidInventoryContactColumns()

    const [signal, abortRequest] = useAbortController();
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        data: [],
        totalRowCount: 0,
        pageCount: 0,
        filter: '',
        loading: false,
    });

    const onAddRecordClicked = () => {
        showValidContactInputForm();
    }

    // const handleRowEdit = (rowData) => {
    //     showValidContactEditForm(null, { recordToEdit: rowData });
    // }

    // const handleRowCopy = (rowData) => {
    //     const copiedData = {
    //         ...rowData,
    //         id: null,  // Remove ID so a new one will be generated
    //         modelNumber: `${rowData.modelNumber}-COPY`, // Append COPY to model number
    //         sku: `${rowData.sku}-COPY`, // Append COPY to SKU
    //         // Reset specific fields that should be unique or reset for new records
    //         quantityOnHand: 0,
    //         quantityOnOrder: 0,
    //         totalSold: 0,
    //         returned: 0,
    //         lastOrdered: null,
    //         lastReceived: null,
    //         lastSold: null,
    //         createdAt: null,
    //         updatedAt: null
    //     };

    //     showValidContactEditForm(null, { recordToEdit: copiedData, isCopy: true });
    // }

    // const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
    //     const from = pageSize * pageIndex;
    //     updateState({ loading: true });
    //     ValidDataService.getInventoryDataWithLimit(from, pageSize, filters, sortBy, 'contacts', signal).then(result => {
    //         const { code, data } = result;
    //         if (code === 0) {
    //             updateState({
    //                 data: data.data,
    //                 totalRowCount: data.count,
    //                 pageCount: Math.ceil(data.count / pageSize),
    //             });
    //         }
    //         updateState({ loading: false });
    //     }).catch(error => {
    //         if (isLocalDev) {
    //             console.error(error)
    //         }
    //         updateState({ loading: false });
    //     });
    // }, [signal]);

    // const deleteRecordHandler = (rowids) => {
    //     showConfirmationDialog(async (action) => {
    //         if (action === validLookup.confirmationDialogAction.ok) {
    //             const deleteRecordResult = await ValidDataService.deleteInventoryRecord(rowids.map(x => parseInt(x, 10)));
    //             const { code, message } = deleteRecordResult;

    //             if (code === 0) {
    //                 toast.success(message);
    //                 const updateList = state.data.filter(d => !rowids.map(x => parseInt(x, 10)).includes(d.id));
    //                 updateState({ data: updateList });
    //             } else {
    //                 toast.error("Failed to delete record(s)");
    //             }
    //         }
    //         closeConfirmationDialog();
    //     }, {
    //         title: 'Delete record',
    //         message: `Please confirm if you would like to delete ${rowids.length} record(s)?`,
    //     });
    // }

    // const recordAddHandler = (newRecord) => {
    //     const newData = state.data.concat(newRecord);
    //     updateState({ data: newData });
    // }

    // const recordEditHandler = (record) => {
    //     const existingRecord = state.data;
    //     const idx = existingRecord.findIndex(e => e.id === record.id);
    //     const updatesList = existingRecord.map((row) => {
    //         if (row.id === record.id) {
    //             return {
    //                 ...existingRecord[idx],
    //                 ...record,
    //             }
    //         }
    //         return row
    //     });

    //     updateState({
    //         data: updatesList
    //     });
    // }

    return (
        <Box>
            <Typography variant="h4">Contact Lenses</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Manage contact lens inventory, wear schedules, and material properties
            </Typography>
            <Divider sx={{ mb: 2 }} />
            
            <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tab label="Schedules" />
                <Tab label="Materials" />
                <Tab label="Models" />
                <Tab label="Pricing" />
            </Tabs>

            {/* <TabPanel value={tabValue} index={0}>
                <EnhancedTable
                    columns={columns}
                    addRecordHandler={onAddRecordClicked}
                    deleteRecordHandler={deleteRecordHandler}
                    data={state.data}
                    totalRowCount={state.totalRowCount}
                    pageCount={state.pageCount}
                    fetchData={fetchData}
                    loading={state.loading}
                    selectionMode="multi"
                    actions={[
                        {
                            icon: <EditIcon />,
                            onClick: handleRowEdit
                        },
                        {
                            icon: <ContentCopy />,
                            onClick: handleRowCopy
                        },                    
                    ]}
                />
                <ValidContactInputDialog onRecordAdded={recordAddHandler} />
                <ValidContactEditDialog onRecordUpdated={recordEditHandler} onRecordCopied={recordAddHandler} />

                <ConfirmationDialogComp
                    label={{
                        positive: "Confirm",
                        negative: "Cancel",
                    }} />
            </TabPanel> */}

            <TabPanel value={tabValue} index={0}>
                <ContactLensSchedules />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
                <ContactLensMaterials />
            </TabPanel>

            <TabPanel value={tabValue} index={2}>
                <ContactLensModels />
            </TabPanel>

            <TabPanel value={tabValue} index={3}>
                <ContactLensPricing />
            </TabPanel>
        </Box>
    )
}